module.exports = __webpack_public_path__ + "static/media/duoKey.ac9a933d.svg";